import React from "react";
import SEOHead from "./SEOHead";
import Header from "./Header";
import NewHeroSections from "./NewHeroSections";
import FounderStorySection from "./FounderStorySection";
import PressRecognitionSection from "./PressRecognitionSection";
import EnhancedCertificationSection from "./EnhancedCertificationSection";
import PillarsSection from "./PillarsSection";
import CertificationTiersSection from "./CertificationTiersSection";
import DemoSection from "./DemoSection";
import PricingSection from "./PricingSection";
import MentorPartnerSection from "./MentorPartnerSection";
import BestPracticeHubSection from "./BestPracticeHubSection";
import CertifiedDirectorySection from "./CertifiedDirectorySection";
import TrustProofSection from "./TrustProofSection";
import Footer from "./Footer";

const LandingPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <SEOHead 
        title="CNESS - Conscious Business Certification"
        description="Earn a credible, human-centered certification that proves you operate with integrity and measurable impact—without slowing growth."
        url="/"
        keywords="conscious business certification, sustainable business, ethical certification, B-Corp alternative, ESG certification"
      />
      
      <Header />
      
      <main>
        {/* NEW: Animated Figma hero sections */}
        <NewHeroSections />
        
        {/* Our Story Section */}
        <div id="our-story">
          <FounderStorySection />
        </div>
        
        {/* Press & Recognition */}
        <PressRecognitionSection />
        
        {/* All existing sections below */}
        <EnhancedCertificationSection />
        <PillarsSection />
        <CertificationTiersSection />
        <DemoSection />
        <PricingSection />
        <MentorPartnerSection />
        <BestPracticeHubSection />
        <CertifiedDirectorySection />
        <TrustProofSection />
      </main>
      
      <Footer />
    </div>
  );
};

export default LandingPage;